import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import {
  setMiniSidenav,
  setUserAuthState,
  useMaterialUIController,
} from "./context";
import { useContext, useEffect, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./assest/theme";
import Sidenav from "./layoutcontainers/DashboardLayout/components/Sidebar";
import Routes_Data from "./Routes_Data";
import logo from "../src/assest/images/logo.png";
import assets from "./config/assestsConfig";
import UserDetailsContext from "./context/auth";
import ForgotPassword from "./pages/auth copy/components/ForgotPassword";
import Message from "./pages/auth copy/components/Message";
import ResetPassword from "./pages/auth copy/components/ResetPassword";
import Payslip from "./payslip";
import Screening from "./newonboardfolder/screening";
import TechiInterviewTable from "./newonboardfolder/technicalinterviewtable";
import RecrruitmentTable from "./newonboardfolder/RecruitmentTable";
import ProfileTable from "./newonboardfolder/Profiletable";
import RecruitOnboardReport from "./newonboardfolder/Recruitmentonboardingreport";
import NewPassword from "./pages/auth copy/components/Newpassword";
import { useUserDetails } from "./context/auth";

//Keelis import
// import { Appointment } from "./pages/pdf/Appointment";
// import { Nda } from "./pages/pdf/nda/Nda";
// import { Offer } from "./pages/pdf/offer/Offer";

//EG import
import { Appointment } from "./pages/egpdf/Appointment";
import { Nda } from "./pages/egpdf/nda/Nda";
import { Offer } from "./pages/egpdf/offer/Offer";

import { useLoading } from "../src/context/loading";
import Loader from "./pages/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import PrivacyPolicy from "./pages/authentication/hrmsprivacypolicy";

function App() {
  const { user } = useContext(UserDetailsContext);
  const dispatch1 = useDispatch();
  const { isCheckedIn } = useSelector((state) => state.timer);
  const { routesdata } = useUserDetails();
  let pathnames = window.location.pathname;
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    sidenavColor,
    userGroup,
    userAuthenticated,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const { circleLoading, setCirleLoading } = useLoading();
  const is_auth = sessionStorage.getItem("is_auth");
  const noSidenavPaths = [
    "under-maintenance",
    "/log-in",
    "/password-reset/:token",
    "/forgot-password",
    "/password-reseted",
    "/payslip",
    "/createpassword",
    "/onboarddashboard/",
  ];
  function shouldHideSidenav(pathname) {
    return noSidenavPaths.some((path) =>
      pathname.startsWith(path.replace(":token", "")),
    );
  }

  const location = useLocation();
  const showSidenav = !shouldHideSidenav(location.pathname);
  useEffect(() => {
    const getToken = sessionStorage.getItem("token");
    // console.log('getToken:', getToken)
    function onLoad() {
      if (getToken) {
        setIsAuthenticated(true);
        setUserAuthState(dispatch, true);
      } else {
        setIsAuthenticated(false);
        setUserAuthState(dispatch, false);
      }
    }
    onLoad();
  }, []);

  useEffect(() => {
    const link =
      document.querySelector("link[rel~='icon']") ||
      document.createElement("link");

    link.rel = "icon";
    link.href = assets.favicon;
    if (!document.head.contains(link)) {
      document.head.appendChild(link);
    }
  }, []);

  //  useEffect(() => {
  //   if (!isCheckedIn) return;

  //   const interval = setInterval(() => {
  //     dispatch1(incrementTime());
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [isCheckedIn, dispatch1]);

  useEffect(() => {
    if (pathname === "/sign-in") {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("is_auth");
    }
  }, [pathname]);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // const getRoutes = (allRoutes) =>
  //   allRoutes.map((route) => {
  //     if (route.collapse) {
  //       return getRoutes(route.collapse);
  //     }
  //     if (route.route) {
  //       return <Route exact path={route.route} element={route.component} key={route.key} />;
  //     }

  //     return null;
  //   });

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.hidden) return null;

      if (route.route) {
        const routeRequiresAuthentication =
          route.permissions?.authenticated || false;
        const routeRoles = route.permissions?.roles || [];
        let isAuthvalid = false;
        let isRoleValid = false;
        if (routeRoles.includes("all")) {
          isRoleValid = true;
        } else {
          isRoleValid = routeRoles.includes(userGroup);
        }

        if (routeRequiresAuthentication && (userAuthenticated || is_auth)) {
          isAuthvalid = true;
        } else if (!routeRequiresAuthentication) {
          isAuthvalid = true;
        }

        if (isAuthvalid) {
          return (
            <Route
              exact
              path={route.route}
              element={route.component}
              key={route.key}
            />
          );
        } else {
          return <Route path="*" element={<Navigate to="/sign-in" />} />;
        }
      }
      return null;
    });

  return (
    <>
      {userAuthenticated !== null && (
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {layout === "dashboard" &&
            showSidenav &&
            pathnames != "/course-assessment/test" &&
            pathnames != "/course-assessment/congrats" && (
              <>
                {pathname !== "/sign-in" && pathname !== "/authentication" && (
                  <Sidenav
                    color={sidenavColor}
                    brand={assets.logo}
                    brandName="Keelis"
                    routes={routesdata}
                    onMouseEnter={handleOnMouseEnter}
                    onMouseLeave={handleOnMouseLeave}
                  />
                )}
              </>
            )}
          {circleLoading && (
            <div
              style={{ position: "fixed", inset: 0, zIndex: "1000000000000" }}
            >
              <Loader pending={circleLoading} />
            </div>
          )}
          <Routes>
            <Route
              path="/onboarddashboard/screening"
              element={<Screening />}
            ></Route>
            <Route
              path="/onboarddashboard/technicalinterview"
              element={<TechiInterviewTable />}
            ></Route>
            <Route
              path="/onboarddashboard/recruitment"
              element={<RecrruitmentTable />}
            ></Route>
            <Route
              path="/onboarddashboard/profile"
              element={<ProfileTable />}
            ></Route>
            <Route
              path="/onboarddashboard/recruitonboardreport"
              element={<RecruitOnboardReport />}
            ></Route>
            {/* //password reset routes */}
            <Route path="/password-reset/:token" element={<ResetPassword />} />
            <Route
              path="/createpassword/:uid/:token"
              element={<NewPassword />}
            />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="password-reseted" element={<Message />} />
            {/* <Route path="appointment" element={<Appointment />} />
            <Route path="Nda" element={<Nda />} />
            <Route path="/recruitment/Offer" element={<Offer />} /> */}

            {/* Appointment, NDA, Offer Configuration Route Reusable Configuration  */}
            {(() => {
              const companyRoutes = {
                Keelis: {
                  appointment: <Appointment />,
                  nda: <Nda />,
                  offer: <Offer />,
                },
                Xpert: {
                  appointment: <Appointment />,
                  nda: <Nda />,
                  offer: <Offer />,
                },
                Cyber: {
                  appointment: <Appointment />,
                  nda: <Nda />,
                  offer: <Offer />,
                },
                Eg: {
                  appointment: <Appointment />,
                  nda: <Nda />,
                  offer: <Offer />,
                },
              };

              const selectedRoutes = companyRoutes[assets.company];

              return selectedRoutes ? (
                <>
                  <Route
                    path="appointment"
                    element={selectedRoutes.appointment}
                  />
                  <Route path="Nda" element={selectedRoutes.nda} />
                  <Route
                    path="/recruitment/Offer"
                    element={selectedRoutes.offer}
                  />
                </>
              ) : null;
            })()}
            {/* Appointment, NDA, Offer Configuration Route Reusable Configuration*/}

            <Route path="payslip" element={<Payslip />} />
            {getRoutes(routesdata)}
            {/* {assets.company!=='Eg'?
            <Route path="/" element={<Navigate to="/sign-in" />} />
            :
            <Route path="/" element={<Navigate to="/authentication" />} />} */}
            <Route path="/" element={<Navigate to="/sign-in" />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
          <Routes_Data />
        </ThemeProvider>
      )}
    </>
  );
}

export default App;
